import { useTranslation } from 'react-i18next';
import { useNotification } from '@topcon/topcon-utils';

import ConfirmDeletionModal from '../../../components/Modal/ConfirmDeletionModal';
import { useDeleteCustomApplication } from './customApplications.mutations';
import { ClientBody } from '../../../api/generated/pap';
import { useErrorDrawer } from '../../../providers/ErrorDrawerContext/error-drawer.context';

interface Props {
  customApplication: ClientBody;
  open: boolean;
  onClose: (shouldUpdate: boolean) => void;
}

function DeleteCustomApplicationModal({ customApplication, open, onClose }: Props) {
  const notificationService = useNotification();
  const { showError } = useErrorDrawer();
  const { t } = useTranslation('settings');

  const { mutateAsync: deleteCustomApplication } = useDeleteCustomApplication();

  const handleDelete = async () => {
    try {
      await deleteCustomApplication(customApplication.id);
      onClose(true);
    } catch (error: unknown) {
      if (showError(error)) {
        return;
      }
      notificationService.addNotification(
        t('customApplications.customApplicationDeleteError'),
        t('customApplications.customApplicationDeleteErrorDescription', {
          name: customApplication.name,
        }),
        'error'
      );
    }
  };

  return (
    <ConfirmDeletionModal
      title={t('customApplications.deleteModalTitle')}
      description={t('customApplications.deleteModalDescription')}
      text={customApplication.name}
      subText={customApplication.description}
      primaryButtonText={t('customApplications.deleteModalPrimaryButton')}
      primaryButtonVariant="secondary"
      iconName="language"
      imageSrc={customApplication.iconURL || undefined}
      open={open}
      onSubmit={handleDelete}
      onClose={onClose}
    />
  );
}

export default DeleteCustomApplicationModal;
